export default __webpack_public_path__ + "blender.6939f549.png";